import { Pipe, PipeTransform } from '@angular/core';
import { TranslationsLibService } from '@nutricontrol/app360-shared';
import { CurrencyDataModel } from '../../reports.model';

@Pipe({
  name: 'amount',
})
export class AmountPipe implements PipeTransform {
  constructor(public translationsLib: TranslationsLibService) {}

  transform(amount: number, currency: CurrencyDataModel): string {
    if (!currency) {
      return amount.toString();
    }

    const symbol = currency.symbol;
    const symbolPosition = currency.symbol_position;
    const spaceSeparator = currency.space_separator;
    const nbsp = '\u00A0';

    if (symbolPosition === 'left') {
      return symbol + (!!spaceSeparator ? nbsp : '') + amount.toString();
    }

    return amount.toString() + (!!spaceSeparator ? nbsp : '') + symbol;
  }
}
